import { type Tag, tags as t } from "@lezer/highlight";

export type SyntaxTokenStyle = {
  name: string;
  tag: Tag | readonly Tag[];
  color: string;
  fontStyle?: string;
};

export const syntaxHighlightStyles: SyntaxTokenStyle[] = [
  {
    name: "keyword",
    tag: [t.keyword, t.heading],
    color: "var(--purple-600)",
  },
  { name: "name", tag: [t.name, t.variableName], color: "var(--text-primary)" },
  {
    name: "string",
    tag: [t.string, t.special(t.string), t.link, t.url, t.monospace],
    color: "var(--orange-600)",
  },
  {
    name: "number",
    tag: [t.number, t.bool, t.null],
    color: "var(--teal-600)",
  },
  {
    name: "comment",
    tag: [t.comment, t.quote, t.emphasis],
    color: "var(--gray-600)",
    fontStyle: "italic",
  },
  {
    name: "function",
    tag: [t.function(t.variableName), t.function(t.propertyName)],
    color: "var(--sky-600)",
  },
  {
    name: "type",
    tag: [t.className, t.typeName, t.strong],
    color: "var(--pink-600)",
  },
  {
    name: "punctuation",
    tag: [t.operator, t.punctuation],
    color: "var(--gray-800)",
  },
  { name: "inserted", tag: [t.inserted], color: "var(--green-600)" },
  { name: "deleted", tag: [t.deleted], color: "var(--red-600)" },
];
